import { Alert } from '@mui/material'
import React from 'react'

const Emailsent = () => {
  return (
    <div style={{height: '100vh'}}>
      <Alert severity="success" style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h3>A link for email confirmation has been sent to your email address.</h3>
      </Alert>
    </div>

  )
}

export default Emailsent